function Settings() {
  return (
    <svg width={41} height={40} fill="none" viewBox="0 0 41 40" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M26.979 19.998c0 3.534-2.939 6.412-6.55 6.412-3.608 0-6.55-2.878-6.55-6.412 0-3.532 2.942-6.406 6.55-6.406 3.613.002 6.55 2.874 6.55 6.406zm8.263-4.585l-1.032-2.45s2.401-5.414 2.187-5.623l-3.176-3.1c-.221-.215-5.636 2.256-5.636 2.256l-2.498-1.009S22.88 0 22.577 0h-4.484c-.31 0-2.354 5.5-2.354 5.5l-2.494 1.011s-5.529-2.35-5.742-2.14L4.332 7.477c-.22.213 2.305 5.518 2.305 5.518l-1.031 2.447S0 17.602 0 17.892v4.395c0 .306 5.618 2.308 5.618 2.308l1.032 2.443s-2.4 5.41-2.188 5.617l3.175 3.109c.214.21 5.633-2.26 5.633-2.26l2.5 1.013S17.976 40 18.282 40h4.483c.31 0 2.355-5.5 2.355-5.5l2.502-1.013s5.518 2.351 5.732 2.146l3.176-3.106c.22-.217-2.31-5.52-2.31-5.52l1.029-2.446s5.607-2.163 5.607-2.458v-4.392c.002-.301-5.614-2.297-5.614-2.297z"
        fill="#2C2C2C"
      />
    </svg>
  );
}

export default Settings;
